import {ReduceCostos} from './ReduceCostos';
export default ReduceCostos;
